@if (renderMode === 'modal') {
<unity-modal
    title="Notification Settings"
    primaryAction="Save"
    [primaryActionEnabled]="isAuroraEnabled ? hasChanges : true"
    secondaryAction="Cancel"
    (onPrimaryAction)="save()"
    (onClose)="cancel()"
    (onSecondaryAction)="cancel()">
    <ng-container [ngTemplateOutlet]="settingsContent"></ng-container>
</unity-modal>
} @else {
<div class="settings-inline" aurora-light>
    <ng-container [ngTemplateOutlet]="settingsContent"></ng-container>

    <div class="settings-inline-actions">
        <aurora-button variant="primary" [disabled]="!hasChanges" (click)="save()">Save</aurora-button>
    </div>
</div>
}

<ng-template #settingsContent>
    <unity-loading-indicator *ngIf="!model" />

    <ng-container *ngIf="model">
        @if (isAuroraEnabled) {
            <div class="form-group enable_popups">
                <aurora-toggle
                    id="enableInAppNotificationPopups"
                    name="enableInAppNotificationPopups"
                    label="Enable in-app notification popups"
                    [checked]="model.EnableInAppNotificationPopups"
                    (change)="onToggleChange($event, 'EnableInAppNotificationPopups')">
                </aurora-toggle>
            </div>

            <div class="form-group">
                <h2 class="mb-2">Notification Types</h2>

                <aurora-checkbox
                    id="journalEntryNotifications"
                    name="journalEntryNotifications"
                    label="Account Owner - Journal Entries"
                    [checked]="model.JournalEntryNotifications"
                    (change)="onToggleChange($event, 'JournalEntryNotifications')"></aurora-checkbox>

                <aurora-checkbox
                    id="comments"
                    name="comments"
                    label="Comments"
                    [checked]="model.CommentNotifications"
                    (change)="onToggleChange($event, 'CommentNotifications')"></aurora-checkbox>

                <aurora-checkbox
                    id="delegation"
                    name="delegation"
                    label="Task Delegation"
                    [checked]="model.TaskDelegationNotifications"
                    (change)="onToggleChange($event, 'TaskDelegationNotifications')"></aurora-checkbox>

                <aurora-checkbox
                    id="programRevisionNotifications"
                    name="programRevisionNotifications"
                    label="Program Revision"
                    [checked]="model.ProgramRevisionNotifications"
                    (change)="onToggleChange($event, 'ProgramRevisionNotifications')"></aurora-checkbox>

                <aurora-checkbox
                    *sm-tenant-has-facet="TENANT_PERMISSIONS.Flag_Base_Work_Accounts_EmailManagement"
                    id="emailNotifications"
                    name="emailNotifications"
                    label="Account Owner - New Email"
                    [checked]="model.EmailNotifications"
                    (change)="onToggleChange($event, 'EmailNotifications')"></aurora-checkbox>
            </div>

            <div class="form-group">
                <aurora-label id="expirationDurationOfReadNotificationsInDays">Remove read notifications after</aurora-label>
                <aurora-dropdown
                    id="expirationDurationOfReadNotificationsInDays"
                    ariaLabel="Remove read notifications after"
                    [items]="expirationDropdownItems"
                    [value]="model.ExpirationDurationOfReadNotificationsInDays.toString()"
                    (value-change)="onExpirationDurationChange($event)">
                </aurora-dropdown>
            </div>
        } @else {
            <div class="form-group enable_popups">
                <unity-toggle
                        controlName="enableInAppNotificationPopups"
                        [(toggledOn)]="model.EnableInAppNotificationPopups"
                        (onToggle)="toggleInAppNotificationPopups()"
                ></unity-toggle>
                <label for="enableInAppNotificationPopups">Enable in-app notification popups</label>
            </div>

            <div class="form-group">
                <h2 class="mb-2">Notification Types</h2>
                <div class="form-check">
                    <input
                            class="form-check-input"
                            type="checkbox"
                            name="journalEntryNotifications"
                            id="journalEntryNotifications"
                            [(ngModel)]="model.JournalEntryNotifications"
                    >
                    <label class="form-check-label" for="journalEntryNotifications">
                        Account Owner - Journal Entries
                    </label>
                </div>
                <div class="form-check">
                    <input
                            class="form-check-input"
                            type="checkbox"
                            name="comments"
                            id="comments"
                            [(ngModel)]="model.CommentNotifications"
                    >
                    <label class="form-check-label" for="comments">
                        Comments
                    </label>
                </div>
                <div class="form-check">
                    <input
                            class="form-check-input"
                            type="checkbox"
                            name="delegation"
                            id="delegation"
                            [(ngModel)]="model.TaskDelegationNotifications"
                    >
                    <label class="form-check-label" for="delegation">
                        Task Delegation
                    </label>
                </div>
                <div class="form-check">
                    <input
                            class="form-check-input"
                            type="checkbox"
                            name="programRevisionNotifications"
                            id="programRevisionNotifications"
                            [(ngModel)]="model.ProgramRevisionNotifications"
                    >
                    <label class="form-check-label" for="programRevisionNotifications">
                        Program Revision
                    </label>
                </div>
                <div *sm-tenant-has-facet="TENANT_PERMISSIONS.Flag_Base_Work_Accounts_EmailManagement" class="form-check">
                    <input
                            class="form-check-input"
                            type="checkbox"
                            name="emailNotifications"
                            id="emailNotifications"
                            [(ngModel)]="model.EmailNotifications"
                    >
                    <label class="form-check-label" for="emailNotifications">
                        Account Owner - New Email
                    </label>
                </div>
            </div>

            <div class="form-group">
                <label class="form-check-label" for="programRevisionNotifications">Remove read notifications
                    after</label>
                <select [(ngModel)]="model.ExpirationDurationOfReadNotificationsInDays" class="form-select">
                    <option *ngFor="let option of expirationOptions" [value]="option.value">
                        {{option.label}}
                    </option>
                </select>
            </div>
        }
    </ng-container>
</ng-template>
